interface FilterableSortable<T> {
  filter(predicate: (item: T) => boolean): FilterableSortable<T>;
  sort(comparator: (a: T, b: T) => number): FilterableSortable<T>;
  at(index: number): T | undefined;
}

export function incrementName<T>(name: string, existingSources: FilterableSortable<T>, accessor: (item: T) => string) {
  const highestExistingSource = existingSources
    .filter((item) => accessor(item).startsWith(name))
    .sort((a, b) => {
      const aNumber = parseInt(accessor(a).split(" ").pop() || "0", 10);
      const bNumber = parseInt(accessor(b).split(" ").pop() || "0", 10);
      return bNumber - aNumber;
    })
    .at(0);
  const highestExistingName = highestExistingSource ? accessor(highestExistingSource) : `${name} 0`;
  const number = parseInt(highestExistingName.split(" ").pop() || "0", 10) + 1;
  return `${name} ${number}`;
}
